export function useCommandResolver(getAvailable) {
  function resolve(input) {
    const available = getAvailable()
    for (const c of available) {
      if (!(c && (c.method || c.path) && (c.usage || c.name))) continue
      const usage = (c.usage || c.name).trim()
      const res = matchUsage(usage, input)
      if (res) {
        const url = buildUrlFromTemplate(c.path, res)
        if (!url) continue
        const method = (c.method || 'GET').toString().toUpperCase()
        if (!url.startsWith('/')) continue
        if (!['GET','POST'].includes(method)) continue
        return { method, path: url, meta: c }
      }
    }
    return null
  }

  return { resolve, matchUsage, buildUrlFromTemplate }
}

export function matchUsage(usage, input) {
  const utoks = (usage || '').split(/\s+/)
  const itoks = (input || '').split(/\s+/)
  const params = {}
  let ui = 0
  for (let i = 0; i < utoks.length; i++) {
    const ut = utoks[i]
    const isParam = /^<[^>]+>$/.test(ut)
    if (isParam && i === utoks.length - 1) {
      const name = ut.slice(1, -1)
      const rest = itoks.slice(ui).join(' ')
      if (!rest) return null
      params[name] = rest
      ui = itoks.length
      break
    }
    if (isParam) {
      const name = ut.slice(1, -1)
      if (ui >= itoks.length) return null
      params[name] = itoks[ui++]
    } else {
      if (ui >= itoks.length || itoks[ui] !== ut) return null
      ui++
    }
  }
  if (ui !== itoks.length) return null
  return params
}

export function buildUrlFromTemplate(tpl, params) {
  if (!tpl) return null
  let url = tpl
  return url.replace(/\{([^}]+)\}/g, (_, name) => encodeURIComponent(params[name] ?? ''))
}

